import React from "react";
import "./style.scss";
import { MdCheck } from "react-icons/md";

export interface CheckoutStep {
  label: string;
  onClick?: () => void;
}

interface IProps {
  steps: CheckoutStep[];
  activeStep: number; // 0-indexed
}

const CheckoutStepper: React.FC<IProps> = ({ steps, activeStep }) => {
  return (
    <div className="checkout-stepper">
      {steps.map((step, index) => {
        const isCompleted = index < activeStep;
        const isActive = index === activeStep;
        const isClickable = !!step.onClick;

        return (
          <React.Fragment key={index}>
            <div
              className={[
                "checkout-stepper__step",
                isActive ? "checkout-stepper__step--active" : "",
                isCompleted ? "checkout-stepper__step--completed" : "",
                isClickable ? "checkout-stepper__step--clickable" : "",
              ]
                .filter(Boolean)
                .join(" ")}
              onClick={step.onClick}
            >
              <div className="checkout-stepper__circle">
                {isCompleted ? <MdCheck /> : <span>{index + 1}</span>}
              </div>
              <span className="checkout-stepper__label">{step.label}</span>
            </div>

            {index < steps.length - 1 && (
              <div
                className={[
                  "checkout-stepper__connector",
                  isCompleted ? "checkout-stepper__connector--completed" : "",
                ]
                  .filter(Boolean)
                  .join(" ")}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default CheckoutStepper;
